import { useState } from "react";

import Image from "next/image";

import { INotification } from "shared/components/organisms/AppNotification/@types";
import { IActivitieDataEndingMetaData } from "shared/components/organisms/AppNotification/@types/activeDateEndingTypes";
import { ClockIcon } from "shared/components/organisms/AppNotification/assets/icons/ClockIcon";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";

import { ActivitieDataEndingNotificationContainer } from "./styles";

interface IActivitieDataEndingNotificationProps {
  notification: INotification<IActivitieDataEndingMetaData>;
}

export const ActivitieDataEndingNotification = ({
  notification,
}: IActivitieDataEndingNotificationProps) => {
  const [failedToLoadImage, setFailedToLoadImage] = useState(false);

  const notificationType = notification?.type;

  const imageSrc =
    notification?.metadata?.location?.lesson?.lesson_thumbnail ??
    notification?.metadata?.location?.group?.group_logo_horizontal ??
    "";
  const contentTitle =
    notification?.metadata?.location?.lesson?.lesson_title ??
    notification?.metadata?.location?.group?.group_title;

  const notificationTitleMap = {
    lesson_finishes_in_7_days: "Esta atividade encerra em breve!",
    lesson_finishes_in_3_days: "Não perca o prazo!",
    lesson_finishes_today: "🚨 Atividade se encerra hoje!",
  };

  const notificationContentMap = {
    lesson_finishes_in_7_days: (
      <span>
        Estamos passando para lembrar que Você tem <b>7 dias</b> para concluir
        essa atividade.
      </span>
    ),
    lesson_finishes_in_3_days: (
      <span>
        Estamos passando para lembrar que Você tem <b>3 dias</b> para concluir
        essa atividade.
      </span>
    ),
    lesson_finishes_today:
      "Não se esqueça! Hoje é o último dia para concluir a atividade.",
  };

  return (
    <ActivitieDataEndingNotificationContainer
      shouldChangeBackground={
        notificationType === "lesson_finishes_in_3_days" ||
        notificationType === "lesson_finishes_in_7_days"
      }
    >
      <Notification.Container wasReaded={!!notification?.read_at}>
        <Notification.IllustrationContainer>
          <ClockIcon />
        </Notification.IllustrationContainer>

        <Notification.Title.Container>
          <Notification.Title.Highlight>
            {notificationTitleMap?.[notificationType]}
          </Notification.Title.Highlight>

          <Notification.Content.Text>
            {notificationContentMap?.[notificationType]}

            <div className="content-image">
              <Image
                src={imageSrc}
                alt=""
                width={71}
                height={40}
                onError={() => setFailedToLoadImage(true)}
                style={{
                  backgroundColor: failedToLoadImage
                    ? notification?.metadata?.location?.group
                        ?.group_primary_color
                    : "transparent",
                }}
              />

              <span title={contentTitle}>{contentTitle}</span>
            </div>

            <ConsolePageForm.Button id="" variant="info">
              Acessar atividade
            </ConsolePageForm.Button>
          </Notification.Content.Text>
        </Notification.Title.Container>

        <Notification.Footer.Container>
          <Notification.Footer.Text>
            {formatTimeAgo(notification?.created_at)}
          </Notification.Footer.Text>
        </Notification.Footer.Container>
      </Notification.Container>
    </ActivitieDataEndingNotificationContainer>
  );
};
